import * as React from "react";

function SvgComponent(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={64} height={64} viewBox="0 0 64 64" {...props}>
      {/* Outer Circular Background */}
      <circle cx="32" cy="32" r="28" fill="#f6d19c" />

      {/* Chip Body */}
      <rect x="16" y="16" width="32" height="32" rx="6" fill="#d9e7f8" stroke="#554c86" strokeWidth="2" />

      {/* Inner Square */}
      <rect x="24" y="24" width="16" height="16" rx="2" fill="#f9a4a4" stroke="#554c86" strokeWidth="2" />

      {/* Pins */}
      {[...Array(4)].map((_, i) => (
        <>
          {/* Top Pins */}
          <rect
            x={20 + i * 8}
            y="6"
            width="4"
            height="6"
            rx="2"
            fill="#d9e7f8"
            stroke="#554c86"
            strokeWidth="2"
          />
          <circle cx={22 + i * 8} cy="4" r="2" fill="#a6a5d7" stroke="#554c86" strokeWidth="1" />

          {/* Bottom Pins */}
          <rect
            x={20 + i * 8}
            y="52"
            width="4"
            height="6"
            rx="2"
            fill="#d9e7f8"
            stroke="#554c86"
            strokeWidth="2"
          />
          <circle cx={22 + i * 8} cy="58" r="2" fill="#a6a5d7" stroke="#554c86" strokeWidth="1" />

          {/* Left Pins */}
          <rect
            x="6"
            y={20 + i * 8}
            width="6"
            height="4"
            rx="2"
            fill="#d9e7f8"
            stroke="#554c86"
            strokeWidth="2"
          />
          <circle cx="4" cy={22 + i * 8} r="2" fill="#a6a5d7" stroke="#554c86" strokeWidth="1" />

          {/* Right Pins */}
          <rect
            x="52"
            y={20 + i * 8}
            width="6"
            height="4"
            rx="2"
            fill="#d9e7f8"
            stroke="#554c86"
            strokeWidth="2"
          />
          <circle cx="58" cy={22 + i * 8} r="2" fill="#a6a5d7" stroke="#554c86" strokeWidth="1" />
        </>
      ))}
    </svg>
  );
}

export default SvgComponent;
